/**
 * @param filter {String}
 * True  filter for FTL
 * False filter for LTL
 */
function getBusinessFilter(filter, field = 'has_ftl_shipper_order') {
  if (!filter) return {};

  return {
    [field]: filter === 'FTL',
  };
}

export default getBusinessFilter;
